module.exports = __webpack_public_path__ + "img/image14.3addbdfd.jpeg";